<template>
  <div class="space-between-y">
    <div class="container-left space-between-x">
      <input-item label="请输入关键字进行搜索">
        <el-input v-model="form.keyword" placeholder="请输入关键字"></el-input>
      </input-item>

      <input-item>
        <el-button @click="getList" type="primary">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column width="180" show-overflow-tooltip prop="logTime" label="时间">
        <template v-slot="scope">
          {{ utils.date.format(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="frontEndId" label="前端应用"></el-table-column>
      <el-table-column show-overflow-tooltip prop="clientUrl" label="前端页面"></el-table-column>
      <el-table-column show-overflow-tooltip prop="operationType" label="操作类型"></el-table-column>
      <el-table-column show-overflow-tooltip prop="fileSize" label="文件大小">
        <template v-slot="scope">
          <div v-if="scope.row.fileSize === 0" class="info-text">
            {{ (scope.row.fileSize / 1000 / 1000).toFixed(2) + 'MB' }}
          </div>
          <div v-else>
            {{ (scope.row.fileSize / 1000 / 1000).toFixed(2) + 'MB' }}
          </div>

        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="fileUrl" label="文件URL">
        <template v-slot="scope">
          <a :href="scope.row.fileUrl" target="_blank">{{ scope.row.fileUrl }}</a>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="isCacheHit" label="命中缓存">
        <template v-slot="scope">
          {{ scope.row.isCacheHit ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="ipAddress" label="发起请求所在IP"></el-table-column>
      <el-table-column show-overflow-tooltip prop="userId" label="用户ID"></el-table-column>
      <el-table-column show-overflow-tooltip prop="userName" label="用户名"></el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getList()"></pagination>

  </div>
</template>

<script>
import Pagination from "@/components/base/layout/Pagination.vue";
import {sys} from "@/api/sys";
import InputItem from "@/components/base/layout/InputItem.vue";
import {utils} from "@/util/utils";

export default {
  name: 'LogCos',
  computed: {
    utils() {
      return utils
    }
  },
  components: {InputItem, Pagination},

  data() {
    return {
      form: {
        keyword: "",
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      list: [],

      isLoading: false,
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getList(current) {

      if (current === null) {
        this.page.current = 1;
      }

      sys.listLogCos(this.page.size, this.page.current, this.form.keyword).then(res => {
        let page = res.data;
        this.list = page?.list;
        this.page.total = page?.total;
      })
    },
  },

}
</script>

<style scoped>

</style>